import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;
/**
 * JS port of ImageWidgetRenderer.java
 */
export function renderImageWidget(context, widget, parent, override = null) {

    const url = getImageUrl(context, widget, override);
    if (!url) return;

    // <a class="widget image_widget">
    const anchor = context.document.createElement("a");
    anchor.classList.add("widget", "image_widget");
    const breakpoint = context.currentBreakpoint;

    // <img>
    const img = context.document.createElement("img");
    img.setAttribute("src", url);
    const styles = {
        ...applyBorderStyles(widget),
        ...getBaseStyles(widget, breakpoint)
    };

    img.setAttribute("alt", getImageAltText(widget));

    anchor.appendChild(img);

    anchor.setAttribute("style", cssUtil.toStyleString(styles));
    anchor.setAttribute("data-widgetId", widget.uid);
    anchor.setAttribute("data-widgetType", widget.type);
    anchor.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(anchor);

    return anchor;
}

function getImageUrl(context, widget, override) {
    let key = null;
    const media = widget.content;

    // override via layout mapping (same as Java)
    if (widget.parameter && override?.content) {
        const overrideContent = getContent(override.content, widget.parameter);
        if (overrideContent?.url) {
            key = overrideContent.url;
        }
        else{
            key = media.url;
        }
    } else if (media?.url) {
        key = media.url;
    }

    if (!key) return null;

    let transformations = "";
    if (media) {
        const props = widget.properties.desktop;
        transformations = getImageTransformations(media, props);
    }

    return `${IMAGE_CDN_ENDPOINT}/${transformations}/${key}`;
}

function getContent(mapping, name) {
    if (!mapping) {
      throw new Error("Mapping cannot be null");
    }
    if (!name) {
      throw new Error("Field name cannot be null");
    }
  
    return mapping.fields
      ?.find(field => field.name === name)
      ?.content ?? null;
}  


function getImageTransformations(image, properties) {
    const transforms = [];
    const crop = properties.crop;
    const layout = properties.layout;

    let width = cssUtil.parseDouble(layout.width);
    let height = cssUtil.parseDouble(layout.height);

    if (!crop) {
        const maxWidth = Math.max(image.width || 0, width);
        width = Math.max(width * 2, maxWidth);
        transforms.push(`w-${width}`);
    } else {
        const {
            zoomWidth,
            zoomHeight,
            width: imgW,
            height: imgH,
            x,
            y
        } = crop;

        transforms.push(`w-${zoomWidth},h-${zoomHeight},c-force`);
        transforms.push(`cm-extract,x-${x},y-${y},w-${imgW},h-${imgH}`);
    }

    transforms.push("q-100,f-auto");

    return `tr:${transforms.join(":")}`;
}


function applyBorderStyles(widget) {
    const styles = {};
    const border = widget?.properties?.desktop?.border;
    if (!border) return styles;

    let color = "";

    if (border.color) {
        if (border.color.type === "gradient") {
            color = cssUtil.getCssGradient(border.color);
        } else if (border.color.type === "solid") {
            color = cssUtil.getCssColor(border.color);
        }
    }

    if (border.radius) {
        const r = border.radius;
        if (r.topLeft) styles["border-top-left-radius"] = `${r.topLeft}px`;
        if (r.topRight) styles["border-top-right-radius"] = `${r.topRight}px`;
        if (r.bottomRight) styles["border-bottom-right-radius"] = `${r.bottomRight}px`;
        if (r.bottomLeft) styles["border-bottom-left-radius"] = `${r.bottomLeft}px`;
    }

    if (color) styles["border-color"] = color;

    const width = border.width || "0";
    styles["border-width"] = `${width}px`;
    styles["border-style"] = "solid";

    return styles;
}

function getImageAltText(widget) {
    return widget?.properties?.desktop?.alt || "";
}